import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="campos-si-no"
// Los sí/no de seguro en tres estados del admin (`opinables/seguros/_campos_si_no`).
//
// Esconde el detalle de los que están «Sin dato» y no tienen texto: con 17 coberturas, los
// campos de detalle vacíos doblaban la sección. Si el detalle ya tiene texto se queda a la vista,
// para no ocultar algo que se va a guardar. Sin JS, todos los detalles se ven.
//
// También mantiene el recuento «N con dato · M sin dato», que el servidor pinta al cargar.
export default class extends Controller {
  static targets = ['campo', 'conDato', 'sinDato']

  connect () {
    this.actualiza()
  }

  actualiza () {
    let sinDato = 0

    this.campoTargets.forEach(campo => {
      const vacio = this.estaSinDato(campo)
      if (vacio) sinDato += 1

      const detalle = campo.querySelector('.rnk-CampoSiNo_Detalle')
      detalle.hidden = vacio && !detalle.querySelector('input').value.trim()
    })

    if (this.hasConDatoTarget) this.conDatoTarget.textContent = this.campoTargets.length - sinDato
    if (this.hasSinDatoTarget) this.sinDatoTarget.textContent = sinDato
  }

  estaSinDato (campo) {
    return campo.querySelector('input[type=radio]:checked').value === ''
  }
}
